import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-ts-client',
	templateUrl:'./TypeScriptClientPluginPage.html',
	styles: [],
	styleUrls:['./TypeScriptClientPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		MarkdownComponent,
],
	standalone:true
})
export class TypeScriptClientPluginPage
{
	mdContent_119 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>typescript-client</artifactId>
</dependency>
\`\`\``;
	mdContent_120 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:typescript-client:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_121 = `\`\`\`java
@NgComponent("my-widget")
public class MyWidget extends DivSimple<MyWidget>
        implements INgComponent<MyWidget> {

    @NgField("title = 'Hello World'")
    String title;

    @NgOnInit
    public void onInit() {
        add(new Paragraph<>().setText("{{ title }}"));
    }
}
\`\`\``;
	mdContent_122 = `\`\`\`java
@NgComponent("settings-page")
@NgRoutable(path = "settings", parent = {AppComponent.class})
@NgRouteData(key = "title", value = "'Settings'")
public class SettingsPage extends DivSimple<SettingsPage>
        implements INgComponent<SettingsPage> { }
\`\`\``;
	mdContent_123 = `\`\`\`java
@NgComponent("my-widget")
public class MyWidget extends DivSimple<MyWidget>
        implements INgComponent<MyWidget> {

    @NgField("title = 'Hello World'")
    String title;

    @NgOnInit
    public void onInit() {
        add(new Paragraph<>().setText("{{ title }}"));
    }
}
\`\`\``;
}
